export default {
  CREATE_ORDER: {
    pending: 'CREATE_ORDER/pending',
    fulfilled: 'CREATE_ORDER/fulfilled',
    rejected: 'CREATE_ORDER/rejected'
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/Booking/ActioTypes.js